import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import ContentDisplay from '../components/content-display/content-display';
import DefaultLayout from '../components/default-layout/default-layout';
import SEO from '../components/seo/seo';
import WYSIWYG from '../components/wysiwyg/wysiwyg';
import ParkingAccordion from '../components/parking-policy/parking-accordion.js';
import SlideshowSmall from '../components/slideshow-small/slideshow-small';
import { get } from '../helpers/hooks-helpers';
import { useCurrentFilter } from '../hooks/use-current-filter';

const ParkingPage = ({ data }) => {
  const informationData = data.allNodeInformation.edges[0]?.node;
  const informationSummary = informationData?.description?.processed || '';
  const parkingPageData = data.allNodePage.edges[0]?.node;
  const parkingBody = parkingPageData?.body;
  const policies = data?.allNodeParkingPolicy?.edges?.map(edge => edge.node) ?? [];
  const sidebarData = useCurrentFilter(get(data, 'SidebarPromo.relationships.field_promoted_content', []));
  
  parkingPageData.sidebarContent = (
      <SlideshowSmall data={sidebarData.slice(0, 1)} />
    );
  return (
    <DefaultLayout data={data}>
      <SEO
        title="Finding a Place to Park"
        description="Where to park at City Springs."
        siteConfig={data.site.siteMetadata}
        pageUrl="/parking"
      />     
        <ContentDisplay title={parkingPageData?.field_long_title || parkingPageData?.title} content={parkingPageData} imageLocation="sidebar" sidebarContent={parkingPageData.sidebarContent}>
          {/* Information Node */}
          <WYSIWYG>
            <div
              dangerouslySetInnerHTML={{ __html: informationSummary || '' }}
            />         
          </WYSIWYG>
          <ParkingAccordion policies={policies} />
          <WYSIWYG>
            <div
              dangerouslySetInnerHTML={{ __html: parkingBody?.processed || '' }}
            />         
          </WYSIWYG>
        </ContentDisplay>
     
    </DefaultLayout>
  );
};

ParkingPage.propTypes = {
  data: PropTypes.object
};

export default ParkingPage;

export const query = graphql`
  query ParkingQuery {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    allNodeParkingPolicy {
      edges {
        node {
          title
          field_policy_type
          field_rate
          field_title_override
          field_valet_not_in_operation
          field_date {
            value
            end_value
          }
        }
      }
    }
    allNodePage(filter: {path: {alias: {eq: "/parking"}}}) {
      edges {
        node {
          id
          body {
            processed
          }
          title
          field_long_title
        }
      }
    }
    allNodeInformation(filter: {drupal_internal__nid: {eq: 4928}}) {
      edges {
        node {
          title
          description {
            processed
          }
        }
      }
    }
      SidebarPromo: taxonomyTermPromotion(
      drupal_id: { eq: "4a1f98b8-f191-496d-ac7d-db604fcd6840" }
    ) {
      ...Promoted
    }
     allNodeEvent(
      sort: { fields: [field_date___value], order: ASC },
      filter: { field_private_event: { ne: true } }
    ) {
      edges {
        node {
          ...UpcomingEvents
        }
      }
    }
  }
`;
